import { Injectable } from '@angular/core';
import { Observable, retry } from 'rxjs';
import { FopModeService } from '../fop-mode/fop-mode.service';
import { DeviceSource, ILicenseRequest, ILicenseResponse, ILicenseUsage } from '../../../model/license';
import { ClientsService } from '../clients/clients.service';
import { take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { LicenseState } from './store/license.reducers';
import * as LicenseActions from './store/license.actions';
import { licenseSelector } from './store/license.selectors';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class LicenseService {
    private fopMode = true;

    constructor(
        private readonly store: Store<LicenseState>,
        private readonly clientsService: ClientsService,
        private readonly fopModeService: FopModeService,
        private readonly authenticationService: AuthenticationService
    ) {
        fopModeService
            .getFopConfig()
            .pipe(take(1), retry(3))
            .subscribe(fopConfig => {
                this.fopMode = fopConfig.fopModeEnabled;
            });
    }

    public activateDevice() {
        const licenseRequest: ILicenseRequest = {
            deviceId: this.clientsService.getCorrelationId(),
            deviceSource: this.fopMode ? DeviceSource.FOP : DeviceSource.MOP,
            user: this.authenticationService.getUsername()
        };
        this.store.dispatch(LicenseActions.activateLicenseRequest({ licenseRequest }));
    }

    public setLicenseState(licenseResponse: ILicenseResponse) {
        this.store.dispatch(LicenseActions.setActiveLicense({ licenseResponse }));
    }

    public getLicenseState(): Observable<LicenseState> {
        return this.store.select(licenseSelector);
    }

    public setLicenseUsage(licenseUsage: ILicenseUsage) {
        this.store.dispatch(LicenseActions.setLicenseUsage({ licenseUsage }));
    }
}
